module.exports = "<div class=\"modal-thinker-container\">\r\n    <div class=\"modal-thinker\">\r\n        <div class=\"big-thinker\"></div>\r\n        <h3 class=\"message\">{{Model.Message}}</h3>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/plugins/full-screen-thinker.html
// module id = 435
// module chunks = 1